<template>
  <!-- 图片文件上传预览容器 -->
  <div class="container">
    <div
      :class="{ imgView: true, imgViemMargin: isMargin }"
      v-show="imgList.length"
      v-for="(item, index) in imgList"
      :key="index"
    >
      <div v-if="item.type == 'mp4'" class="imgView-img">
        <video
          src="https://shop-sk.xunyaogu.com/SKB2BApi/UploadFile/categorys/2025_12/134090490263001361.mp4"
          class="imgView-img"
          controls="controls"
        >
          您的浏览器不支持视频播放
        </video>
      </div>
      <div v-if="item.type !== 'mp4'">
        <el-image
          class="imgView-img"
          :src="item.url"
          fit="cover"
          :z-index="20000"
          :preview-src-list="viewList"
        >
          <template slot="error">
            <div
              class="image-slot"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 100%;
                background-color: #f5f7fa;
              "
            >
              <i
                class="el-icon-picture-outline"
                style="font-size: 40px; color: #909399"
              ></i>
            </div>
          </template>
        </el-image>
      </div>
      <span
        class="imgView-del el-icon-circle-close"
        v-if="isDelete"
        @click="handleDel(item)"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "imgView",
  props: {
    //图片列表
    imgList: {
      type: Array,
      default() {
        return [];
      },
    },
    //是否显示删除
    isDelete: {
      type: Boolean,
      default: false,
    },
    //是否有外边距
    isMargin: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    /**返回开启预览地址 */
    viewList() {
      return this.imgList.map((item) => {
        return item.url;
      });
    },
  },
  methods: {
    handleDel(item) {
      console.log(item, "1111111111111111");
      this.$emit("handleDel", item);
    },
  },
};
</script>

<style scoped>
.container {
  display: inline-block;
  width: auto;
  height: auto;
}
/* 商品图片上传预览 */
.imgView {
  display: inline-block;
  position: relative;
  height: 100px;
  width: 100px;
  vertical-align: middle;
}
.imgViemMargin {
  margin-right: 10px;
  margin-bottom: 5px;
}
.imgView-img {
  width: 100%;
  height: 100%;
}
.imgView-del {
  position: absolute;
  width: 20px;
  height: 20px;
  top: -10px;
  right: -10px;
  font-size: 20px;
  color: #f56c6c;
  opacity: 0.5;
  transition: opacity 0.2s;
}
.imgView-del:hover {
  opacity: 1;
}
</style>
